<button *ngIf="elerheto" type="button" class="ko-gomb" [disabled]="tiltva" (click)="nyit()" [title]="cim" [attr.aria-label]="cim">
  <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path fill="currentColor" d="M3 5a2 2 0 0 1 2-2h3v2H5v3H3V5zm13-2h3a2 2 0 0 1 2 2v3h-2V5h-3V3zM3 16h2v3h3v2H5a2 2 0 0 1-2-2v-3zm16 3v-3h2v3a2 2 0 0 1-2 2h-3v-2h3zM7 7h1.5v10H7V7zm3 0h1v10h-1V7zm2.5 0H15v10h-2.5V7zM16 7h1v10h-1V7z"/></svg>
</button>

<div class="ko-fatyol" *ngIf="nyitva" (click)="bezar()">
  <div class="ko-ablak" (click)="$event.stopPropagation()">
    <div class="ko-fej">
      <b>{{ cim }}</b>
      <button type="button" class="ko-zar" (click)="bezar()" aria-label="Bezárás">✕</button>
    </div>
    <div class="ko-kep">
      <video #video playsinline muted autoplay></video>
      <div class="ko-cel"></div>
    </div>
    <div class="ko-hiba" *ngIf="hiba">{{ hiba }}</div>
    <div class="ko-lab" *ngIf="!hiba">
      <ng-container *ngIf="!utolso">Tartsd a vonalkódot a keretbe.</ng-container>
      <ng-container *ngIf="utolso">Utolsó: <b>{{ utolso }}</b><span *ngIf="folyamatos"> · {{ darab }} olvasás</span></ng-container>
    </div>
    <button *ngIf="folyamatos" type="button" class="ko-kesz" (click)="bezar()">Kész</button>
  </div>
</div>
